import { render, staticRenderFns } from "./ExpertCard.vue?vue&type=template&id=ab0dc06c&scoped=true"
import script from "./ExpertCard.vue?vue&type=script&lang=js"
export * from "./ExpertCard.vue?vue&type=script&lang=js"
import style0 from "./ExpertCard.vue?vue&type=style&index=0&id=ab0dc06c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0dc06c",
  null
  
)

export default component.exports